import { render, staticRenderFns } from "./UploadButton.vue?vue&type=template&id=791ebc71&scoped=true&"
import script from "./UploadButton.vue?vue&type=script&lang=js&"
export * from "./UploadButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791ebc71",
  null
  
)

export default component.exports